import TYR from './cookie_constant';
import { getCookie, setCookie } from './handle_cookie';


class Customer {
  constructor() {
    if (typeof Customer._instance === 'object') {
      return Customer._instance;
    }
    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.country = null;
    this.allStores = TYROOLA.globals.allStores;
    this.currentStore = TYROOLA.globals.store;
    Customer._instance = this;
    this.findMatchStore();
  }

  findMatchStore() {
    const isSubStore = this.currentStore.split('_').length > 1;
    const _onlyIfSubStore = ({ storeName }) => isSubStore ? storeName.includes('_') : true;
    this.allStores && this.allStores.find((item) => {
      if (
        (item.timezones && item.timezones.includes(this.timezone)
          && _onlyIfSubStore(item))
      ) {
        this.country = { ...item };
        return this.country;
      } else {
        return null;
      }
    });
  }

  getCountryCode() {
    return this.country && this.country.countryCode;
  }

  getCountryUrl() {
    return this.country ? this.country.baseUrl : '';
  }

  getCountryName() {
    return this.country ? this.country.name : '';
  }
}

class Store {
  constructor() {
    if (typeof Store._instance === 'object') {
      return Store._instance;
    }
    Store._instance = this;
    this.countryCode = TYROOLA.globals.store;
    this.storeUrl = TYROOLA.globals.storeUrl;
  }

  static isCounterpartStoreExists(store, isSubStore) {
    const stores = TYROOLA.globals.allStores;
    const predicate = isSubStore ? `${store}_SCA` : store;
    const isPresent = stores.some((el) => el.storeName === predicate);
    return isPresent;
  }

  getCountryCode() {
    return this.countryCode;
  }

  getCountryUrl() {
    return this.storeUrl;
  }
}

class CustomerCountryChoice {

  constructor() {
    this.storeCountryCode = null;
    this.customerCountryCode = null;
    this.domainTarget = null;
    this.customerCountryName = null;
    this.init();

  }

  static getCustomerTimezone() {
    const customer = new Customer();
    return customer.timezone;
  }

  static getCustomerRedirectUrl() {
    const customer = new Customer();
    return customer.getCountryUrl();
  }

  static getStoreUrl() {
    const store = new Store();
    return store.getCountryUrl();
  }

  init() {
    const customer = new Customer();
    const store = new Store();
    this.isShowPopup = false;
    this.currentDate = new Date();
    this.storeCountryCode = store.getCountryCode();
    this.customerCountryCode = customer.getCountryCode();
    this.domainTarget = customer.getCountryUrl();
    this.customerCountryName = customer.getCountryName();

    return this;
  }

  setParamUrl(countryCode) {
    let params = new URLSearchParams(window.location.search);
    params.set(TYR.CUSTOMER_COUNTRY_CODE, countryCode);
    history.pushState(null, null, '?' + params.toString());
  }

  saveDefaultStore() {
    setCookie(TYR.CUSTOMER_COUNTRY_CODE, this.storeCountryCode, 1);
    this.setParamUrl(this.storeCountryCode);
  }

  saveChosenCountry(countryCode, url) {
    setCookie(TYR.CUSTOMER_TARGET_DOMAIN, url, 1);
    setCookie(TYR.CUSTOMER_COUNTRY_CODE, countryCode, 1);
  }

  redirectToCountryStore(url) {
    if (url) return (window.location.href = url);
  }

  checkingCustomerParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const params = urlParams.get(TYR.CUSTOMER_COUNTRY_CODE);
    return params;
  }

  checkingCustomerCountryCode() {
    const customerCookieCountryCode = getCookie(TYR.CUSTOMER_COUNTRY_CODE);
    return customerCookieCountryCode;
  }

  checkingDomainTarget() {
    const target = getCookie(TYR.CUSTOMER_TARGET_DOMAIN);
    return target;
  }

  checkingCurrentStore() {
    const currentStore = this.storeCountryCode.split('_');
    const checkingStore =
      this.customerCountryCode &&
      this.customerCountryCode !== currentStore[0]; //true
    return checkingStore;
  }


  _targetStoreExists() {
    const isSubStore = this.storeCountryCode.split('_').length > 1;
    return Store.isCounterpartStoreExists(this.customerCountryCode, isSubStore);
  }

  shouldDisplayCountryChoice() {
    const params = this.checkingCustomerParam();
    const customerCookieCountryCode = this.checkingCustomerCountryCode();
    const checkingStore = this.checkingCurrentStore();
    const checkingCookies = customerCookieCountryCode === ''; // true;
    const checkingParam = params && params === '1'; // true

    if (checkingStore && checkingCookies && checkingParam === null && this._targetStoreExists()) {
      this.isShowPopup = true;
      return this.isShowPopup;
    }

    if (
      (checkingParam &&
        this.customerCountryCode === null &&
        customerCookieCountryCode.length > 0) ||
      customerCookieCountryCode === this.storeCountryCode
    ) {
      this.isShowPopup = false;
      return this.isShowPopup;
    }

    if (
      customerCookieCountryCode &&
      customerCookieCountryCode !== this.storeCountryCode
    ) {
      const target = this.checkingDomainTarget();
      this.redirectToCountryStore(target);
      this.isShowPopup = false;
      return this.isShowPopup;
    }
  }

  shouldRedirect() {
    this.saveChosenCountry(this.customerCountryCode, this.domainTarget);
    return `${this.domainTarget}?${TYR.CUSTOMER_COUNTRY_CODE}=${this.customerCountryCode}`;
  }
}

export default CustomerCountryChoice;